import { Injectable } from '@angular/core';
import * as bootstrap from 'bootstrap'; // 導入 Bootstrap 的 Tooltip 類

@Injectable({
  providedIn: 'root'
})
export class GeneralService {
  
    constructor(
    ) { }

    /**
	 * 初始化boostrap tooltips
	 */
	public initTooltips() {
		const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
    })
	}
}
